import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';
import { toast } from 'react-toastify';

export const getAllSubcategoryThunk = createAsyncThunk(
  'subcategories/getSubCategories',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getAllSubCategory(config);

      return response.data;
    } catch (error) {
      console.log(error);


    }
  }
);



export const deletesubCategoriesThunk = createAsyncThunk(
  'subcategories/deletesubCategories',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deletesubCategory(id?.id ?? id, id?.password);
      dispatch(setSubcategoryRefresh())
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);


export const updatesubCategory = createAsyncThunk(
  'subcategory/updatesubCategory',
  async (subcategorydata, { rejectWithValue }) => {
    try {
      const { data, status } = await api.updatesubCategory(subcategorydata);
      toast.success(data?.data?.message)
      return status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong')

      return rejectWithValue(error.response.data);
    }
  }
);


export const exportSubcategoryThunk = createAsyncThunk(
  'subcategories/exportSubcategory',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.exportSubcategory(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deletemultiplesubCategoriesThunk = createAsyncThunk(
  'categories/deletemultiplesubCategoriesThunk',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deletemultipleCategory(id);
      dispatch(setSubcategoryRefresh())
      dispatch(setSelectAllsubCat(false))
      dispatch(setSelectedsubIds([]))
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);

// Slice for categories
const subcategorySlice = createSlice({
  name: 'categories',
  initialState: {
    editSubCategory: null,
    subcategory: [],
    filteredCategories: [],
    loading: false,
    refresh: false,
    error: null,
    exportLoading:false,
    page:1,
    selectedIds:[],
    selectAll:false
  },
  reducers: {
    setSubcategory: (state, action) => {
      state.filteredCategories = action.payload
    },
    setSubcategoryRefresh: (state, action) => {
      state.refresh = !state.refresh
    },
    seteditSubCategory: (state, action) => {
      state.editSubCategory = action.payload;
    },
    setSubcategoryPage:(state,action)=>{
      state.page = action.payload
    },
    setSelectedsubIds:(state,action)=>{
      state.selectedIds = action.payload
    },
    setSelectAllsubCat:(state,action) =>{
      state.selectAll = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSubcategoryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllSubcategoryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.subcategory = action.payload;
      })
      .addCase(getAllSubcategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //delete
      .addCase(deletesubCategoriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletesubCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deletesubCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //update
      .addCase(updatesubCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatesubCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.editSubCategory = null; // Clear editCategory after update
      })
      .addCase(updatesubCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //export
      .addCase(exportSubcategoryThunk.pending, (state) => {
        state.exportLoading = true;
      })
      .addCase(exportSubcategoryThunk.fulfilled, (state, action) => {
        state.exportLoading = false;
     
      })
      .addCase(exportSubcategoryThunk.rejected, (state, action) => {
        state.exportLoading = false;
      })
  },
});

export const { setSubcategory, setSubcategoryRefresh,seteditSubCategory,setSubcategoryPage,setSelectedsubIds,setSelectAllsubCat } = subcategorySlice.actions
export default subcategorySlice.reducer;

